import * as React from 'react';

import { Context, initialState } from './types';

export const store = React.createContext<Context>({
	state: initialState,
	dispatch: () => null
});
